export enum CourseSettingsSourceEnum {
  ManualForm = "ManualForm",
  PriceRates = "PriceRates",
}
